export const reducerTypes = {
  GET_ALL_BRANDS: 'reducer/GET_ALL_BRANDS',
  GET_MORE_BRANDS: 'reducer/GET_MORE_BRANDS',
  SET_PAGE_INFO: 'reducer/SET_PAGE_INFO',
  SET_PAGE_INDEX: 'reducer/SET_PAGE_INDEX',
  SET_PAGE_SIZE: 'reducer/SET_PAGE_SIZE',
  GET_BRAND: 'reducer/GET_BRAND',
  IS_LOADING: 'reducer/LOADING_TRUE',
  GET_ALL_PUBLIC_BRANDS: 'reducer/GET_ALL_PUBLIC_BRANDS',
};

export const sagaTypes = {
  GET_ALL_BRANDS: 'saga/GET_ALL_BRANDS',
  GET_MORE_BRANDS: 'saga/GET_MORE_BRANDS',
  GET_BRAND: 'saga/GET_BRAND',
  GET_ALL_PUBLIC_BRANDS: 'saga/GET_ALL_PUBLIC_BRANDS',
};
